import {ThemeOptions} from '@material-ui/core'

const popupBg = '#f9f9f9'


// prevent jquery mobile from enhancing elements with portals
const disableJQM = {'data-enhance': 'false'}
export const baseMuiTheme = {
	typography: {
		useNextVariants: true,
	},
	// generated with https://in-your-saas.github.io/material-ui-theme-editor/
	"palette": {
		"common": {
			"black": "#000",
			"white": "#fff",
		},
		"background": {
			"paper": "#fff",
			"default": "#fafafa",
		},
		"primary": {
			"light": "#a7b6c6",
			"main": "#376798",
			"dark": "#15406d",
			"contrastText": "#fff",
		},
		"secondary": {
			"light": "#81c784",
			"main": "#3ebe28",
			"dark": "#1b8b0c",
			"contrastText": "#fff",
		},
		"error": {
			"light": "#e57373",
			"main": "#e3391d",
			"dark": "#ae1500",
			"contrastText": "#fff",
		},
		// "warning": {
		// 	"light": "#fbf778",
		// 	"main": "#fbe300",
		// 	"dark": "#cbb800",
		// 	"contrastText": "#000",
		// },
		"text": {
			"primary": "rgba(0, 0, 0, 0.87)",
			"secondary": "rgba(0, 0, 0, 0.54)",
			"disabled": "rgba(0, 0, 0, 0.38)",
			"hint": "rgba(0, 0, 0, 0.38)",
		},
	},
	overrides: {
		MuiButton: {
			root: {
				minWidth: 40,
			},
			text: {
				'&:hover': {
					backgroundColor: '#dfdfdf',
				},
			},
			contained: {
				backgroundColor: '#fdfdfd',
				// textTransform: 'none',
				'&:hover': {
					backgroundColor: '#dfdfdf',
				},
			},
			outlined: {
				// textTransform: 'none',
				'&:hover': {
					backgroundColor: '#dfdfdf',
				},
			},

		},
		MuiDialog: {
			paper: {
				backgroundColor: popupBg,
			},
		},
		MuiDivider: {
			root: {
				marginTop: 10,
				marginBottom: 10,
			},
		},
		MuiList: {
			root: {
				backgroundColor: 'inherit', // fixes missing background
			},
		},
		MuiListSubheader: {
			root: {
				marginLeft: 1,
				marginRight: 1,
			},
		},
		MuiListItem: {
			dense: {
				paddingTop: 3,
				paddingBottom: 3,
			},
		},
		MuiTooltip: {
			tooltip: {
				color: '#000',
				backgroundColor: '#fff',
				fontSize: '14px',
				boxShadow: '2px 2px 20px 3px rgba(0,0,0,0.4)',
				maxWidth: 480,
			},
		},
		MuiOutlinedInput: {
			root: {
				height: 38,
				background: '#fff',
				'&:hover:not(.Mui-error) fieldset': {
					borderColor: '#b3b3b3 !important',
				},
			},
			notchedOutline: {
				borderColor: '#ccc',
			},
		},
		MuiInputLabel: {
			outlined: {
				transform: 'translate(14px, 12px) scale(1)',
			},
		},
	},
	props: {
		MuiDialog: disableJQM,
		MuiDrawer: disableJQM,
		MuiTooltip: {
			enterDelay: 500,
			enterTouchDelay: 300,
		},
	},
} as ThemeOptions
